import React, { memo } from "react";

// Memoize the component to prevent unnecessary re-renders during scroll
const Footer = memo(() => {
  const year = new Date().getFullYear();

  return (
    <footer className="dark-blue-footer">
      {/* Decorative Gradient Orbs - Optimized with hardware acceleration */}
      <div className="orb orb-1" aria-hidden="true"></div>
      <div className="orb orb-2" aria-hidden="true"></div>

      <div className="container position-relative">
        <div className="row footer-top g-4">
          
          {/* BRAND SECTION */}
          <div className="col-lg-4 col-md-12 col-12 mb-4">
            <div className="brand-container brand-container-mobile">
              <img
                src="/assets/img/SMILAX_LIGHT1.png" 
                alt="Smilax Logo"
                className="footer-logo"
                loading="lazy" // Improved loading performance
                style={{ filter: "brightness(0) invert(1)" }} 
              />
              <p className="footer-bio">
                Crafting elite smiles with surgical precision and 
                a commitment to luxury dental wellness.
              </p>
              <div className="social-flex">
                <SocialLink href="#" icon="fa-facebook-f" label="Facebook" />
                <SocialLink href="#" icon="fa-instagram" label="Instagram" />
                <SocialLink href="#" icon="fa-linkedin-in" label="LinkedIn" />
              </div>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="col-lg-2 col-md-4 col-6 mb-4">
            <h5 className="column-title">Explore</h5>
            <ul className="footer-nav">
              <li><a href="/">Home</a></li>
              <li><a href="/solutions">Solutions</a></li>
              <li><a href="/about-us">Our Story</a></li>
              <li><a href="/results">Results</a></li>
              <li><a href="/careers">Careers</a></li>
            </ul>
          </div>

          {/* WORKING HOURS */}
          <div className="col-lg-3 col-md-4 col-6 mb-4">
            <h5 className="column-title">Clinical Hours</h5>
            <div className="hours-card">
              <HoursRow label="Mon – Sat" value="9:30 AM – 10 PM" />
              <div className="glow-line"></div>
              <HoursRow label="Sunday" value="By Appointment" />
            </div>
          </div>

          {/* CONTACT SECTION */}
          <div className="col-lg-3 col-md-4 col-12 mb-4">
            <h5 className="column-title">Contact Us</h5>
            <div className="contact-links">
              <ContactPill 
                href="mailto:smilaxdentalclinics@gmail.com" 
                icon="fa-regular fa-envelope" 
                text="smilaxdentalclinics@gmail.com" 
              />
              <ContactPill 
                href="tel:+919321133580" 
                icon="fa-solid fa-phone-volume" 
                text="+91 93211 33580" 
              />
            </div>
          </div>
        </div>

        {/* COPYRIGHT BAR */}
        <div className="footer-base">
          <p>© {year} <span>Smilax Dental Clinics</span>. All Rights Reserved.</p>
        </div>
      </div>

      <style>{`
        /* Optimized CSS Performance */
        .dark-blue-footer {
          background: #1e3a8a; /* Fallback color */
          background: linear-gradient(135deg, #1e3a8a 0%, #1e3a8a 100%);
          padding: 110px 0 35px;
          position: relative;
          overflow: hidden;
          color: #ffffff;
          font-family: 'Inter', sans-serif;
          contain: content; /* Improves browser performance by isolating the footer */
        }

        .orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(100px);
          pointer-events: none;
          opacity: 0.4;
          will-change: transform; /* Hardware acceleration */
          transform: translateZ(0);
        }
        .orb-1 { width: 400px; height: 400px; top: -100px; right: -50px; background: radial-gradient(circle, #3b82f6 0%, transparent 70%); }
        .orb-2 { width: 300px; height: 300px; bottom: -50px; left: -50px; background: radial-gradient(circle, #1e40af 0%, transparent 70%); }

        .footer-logo { width: 260px; margin-bottom: 25px; display: block; height: auto; }
        .footer-bio { font-size: 14.5px; color: rgba(255, 255, 255, 0.7); line-height: 1.8; max-width: 300px; font-weight: 300; }
        .column-title { font-size: 16px; font-weight: 600; text-transform: uppercase; letter-spacing: 1.5px; margin-bottom: 30px; color: #ffffff; position: relative; }
        .column-title::after { content: ""; display: block; width: 25px; height: 2px; background: #3b82f6; margin-top: 10px; box-shadow: 0 0 12px rgba(59, 130, 246, 0.8); }

        .footer-nav { list-style: none; padding: 0; }
        .footer-nav li { margin-bottom: 14px; }
        .footer-nav a { color: rgba(255, 255, 255, 0.65); text-decoration: none; font-size: 14px; transition: color 0.2s ease, padding 0.2s ease; }
        .footer-nav a:hover { color: #ffffff; padding-left: 10px; }

        .hours-card { background: rgba(255, 255, 255, 0.03); padding: 15px; border-radius: 15px; }
        .label { font-weight: 600; font-size: 14px; color: #ffffff; }
        .val { font-size: 13.5px; color: rgba(255, 255, 255, 0.6); }
        .glow-line { height: 1px; width: 100%; background: rgba(255, 255, 255, 0.1); margin: 12px 0; }

        .contact-pill { display: flex; align-items: center; text-decoration: none; color: rgba(255, 255, 255, 0.75); font-size: 14px; transition: color 0.2s ease; }
        .pill-icon { width: 38px; height: 38px; background: rgba(59, 130, 246, 0.15); border: 1px solid rgba(59, 130, 246, 0.3); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-right: 12px; color: #3b82f6; }
        .contact-pill:hover { color: #ffffff; }

        .social-flex { display: flex; gap: 12px; margin-top: 25px; }
        .glass-social { width: 42px; height: 42px; background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #ffffff; transition: transform 0.2s ease, background 0.2s ease; }
        .glass-social:hover { background: #ffffff; color: #3b82f6; transform: translateY(-5px); }

        .footer-base { margin-top: 80px; padding-top: 30px; border-top: 1px solid rgba(255, 255, 255, 0.08); text-align: center; }
        .footer-base p { font-size: 13px; color: rgba(255, 255, 255, 0.4); margin: 0; }
        .footer-base span { color: rgba(255, 255, 255, 0.8); font-weight: 500; }

        @media (max-width: 768px) {
          .dark-blue-footer { padding: 70px 0 30px; }
          .col-6 { flex: 0 0 50%; max-width: 50%; }
          .brand-container-mobile { text-align: center; display: flex; flex-direction: column; align-items: center; }
          .footer-logo { width: 250px; margin: 0 auto 20px; }
          .social-flex { justify-content: center; margin-bottom: 30px; }
          .column-title { font-size: 14px; margin-bottom: 20px; }
          .column-title::after { margin: 10px auto 0; } /* Centered line on mobile */
        }
      `}</style>
    </footer>
  );
});

// Helper Components for Cleaner Main Component
const SocialLink = ({ href, icon, label }) => (
  <a href={href} className="glass-social" aria-label={label} target="_blank" rel="noopener noreferrer">
    <i className={`fa-brands ${icon}`}></i>
  </a>
);

const HoursRow = ({ label, value }) => (
  <div className="hours-row">
    <span className="label">{label}</span>
    <span className="val">{value}</span>
  </div>
);

const ContactPill = ({ href, icon, text }) => (
  <a href={href} className="contact-pill mt-3">
    <div className="pill-icon"><i className={icon}></i></div>
    <span>{text}</span>
  </a>
);

export default Footer;